export const MAX_DISTANCE_NEAREST_CLUB = 15;
